export const minFontSize = 6;
